/*
  *redunx-demo
  bill_yang 2021.06
*/

import { TOGGLE_COUPON } from 'redux/constant';

export const toggleCoupon = (data) => ({ type: TOGGLE_COUPON, data: data });
